import React, { useRef, useEffect } from "react";
import video from "../assets/video.mp4";
function Video({ videoVisiblity, setVideoVisiblity }) {
  const videoReference = useRef(null);
  useEffect(() => {
    if (videoVisiblity) {
        videoReference.current?.play()
    }
  }, [videoVisiblity]);
  return (
    <section className={`video-container ${videoVisiblity ? "visible" : ""}`}>
      <video
        onEnded={() => {
          console.log("Video End");
          setVideoVisiblity(false);
        }}
        ref={videoReference}
      >
        <source src={video} type="video/mp4" />
      </video>
    </section>
  );
}

export default Video;
